import { render, staticRenderFns } from "./TeamBioPopup.vue?vue&type=template&id=c8d7dc1a&scoped=true"
import script from "./TeamBioPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamBioPopup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TeamBioPopup.vue?vue&type=style&index=0&id=c8d7dc1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d7dc1a",
  null
  
)

export default component.exports